import {
  CommunityCreateInterface,
  CommunityInterface,
} from 'modules/commutinies/types/community-interface'
import httpClient from 'shared/utils/http-client'

export const COMMUNITY_API = '/api/dashboard/community/community'

export const removeCommunity = (id: number) => httpClient.delete(`${COMMUNITY_API}/${id}`)

export const updateCommunity = (id: number, data: CommunityCreateInterface) =>
  httpClient.patch<CommunityInterface>(`/api/dashboard/community/community/${id}/settings`, data)

export const createCommunity = (data: CommunityCreateInterface) =>
  httpClient.post<CommunityInterface>(`/api/dashboard/community/community`, data)
